import axios from "axios";

// For Azure deployment, use the production API endpoint by default
// Use || instead of ?? to handle empty strings
const SERVER_HOST = process.env.REACT_APP_SERVER_HOST || "api.koala.fusicong.com";
const SERVER_PORT = process.env.REACT_APP_SERVER_PORT || "443";

// Use HTTPS for production (port 443) and HTTP for local development
const protocol = SERVER_PORT === "443" ? "https" : "http";
const portSuffix = (protocol === "https" && SERVER_PORT === "443") || (protocol === "http" && SERVER_PORT === "80") 
  ? "" 
  : `:${SERVER_PORT}`;
const API_URL = `${protocol}://${SERVER_HOST}${portSuffix}`;

const API = axios.create({
  baseURL: API_URL,
});

API.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem("user");
    const userData = user ? JSON.parse(user) : null;
    if (userData) {
      config.headers.Authorization = `Bearer ${userData.token}`; // Attach token to every request
    }
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginEndpoint = error.config?.url?.includes("/login");
    if (error.response?.status === 401 && !isLoginEndpoint) {
      localStorage.removeItem("user"); // Remove user context if expired/invalid
      window.location.href = "/login"; // Redirect to login page
    }
    return Promise.reject(error);
  }
);

export default API;
